
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/same-sex-divorce",
      function () {
        return require("private-next-pages/practice-areas/same-sex-divorce/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/same-sex-divorce"])
      });
    }
  